import type {
  CreateContractMutationOptions,
  CreateContractPayload,
} from './types';

import { useMutation, useQueryClient } from '@tanstack/react-query';

import { queryKeysContract } from '../queryKeys';

import { createContract } from './createContract';

/**
 * Custom hook for creating a new contract.
 * The contract starts in DRAFT status with optional line items.
 *
 * @param options - Additional options for the mutation.
 * @returns An object containing the mutation function and related properties.
 * @see https://app.dev.vestigas.com/redoc#tag/Contracts/operation/create_contract_contracts_post
 */
export const useMutationCreateContract = (
  options?: CreateContractMutationOptions,
) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload: CreateContractPayload) =>
      createContract(payload),
    onSuccess() {
      queryClient.invalidateQueries({
        queryKey: queryKeysContract.getAll(undefined),
      });
    },
    ...options,
  });
};
